import CachedIcon from "mdi-react/CachedIcon";
import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Button,
  InputGroup,
  Dropdown,
  Modal,
  Table,
  Row,
  Col,
  Spinner,
  Switch,
} from "react-bootstrap";
import currency from "currency.js";
import TableComponent from "../TableComponent";
import {
  Checked,
  CustomerAccountSelectIcon,
  DownloadIcon,
  DeleteIcon,
  FilterCollapseIcon,
  FilterTwoIcon,
  LoaderIcon,
  ViewIcon,
  AddCircleIcon,
} from "../Icons";
import useDebounce, {
  useLocalStorage,
  useQueryParams,
} from "../../utils/hooks";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { format } from "date-fns";
import queryString from "query-string";
import { formatDate, paginationOptions } from "../../utils/helpers";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import ReactPaginate from "react-paginate";
import NoTableItem from "../utils/NoTableItem";
import { debounce, isEmpty, truncate } from "lodash";
import { useNavigate, useOutletContext } from "react-router-dom";
import ConfirmDialog from "../ConfirmDialogue";
import Select from "react-select";
import { toast } from "react-toastify";
import LicenseDetailsModal from "./LicenseDetails";
const packages = [
  {
    value: "erp",
    label: "ERP",
    prices: {
      advance_users: 2144200,
      core_users: 1046250,
      self_service_users: 317750,
    },
  },
  {
    value: "humanResources",
    label: "HR",
    prices: {
      advance_users: 76800,
      core_users: 76800,
      self_service_users: 76800,
    },
  },
  {
    value: "collaborationTools",
    label: "Fexspace",
    prices: {
      advance_users: 76800,
      core_users: 76800,
      self_service_users: 76800,
    },
  },
  {
    value: "formsAndApprovals",
    label: "Incless",
    prices: {
      advance_users: 76800,
      core_users: 76800,
      self_service_users: 76800,
    },
  },
  {
    value: "InvexOne",
    label: "invexone",
    prices: {
      advance_users: 2144200,
      core_users: 1046250,
      self_service_users: 317750,
    },
  },
  {
    value: "payroll",
    label: "Payroll",
    prices: {
      advance_users: 0,
      core_users: 0,
      self_service_users: 50000,
    },
  },
];

// packages.push({
//   value: "ERPHR",
//   label: "ERP + HR",
//   prices: {
//     advance_users:
//       packages[0].prices.advance_users + packages[1].prices.advance_users,
//     core_users: packages[0].prices.core_users + packages[1].prices.core_users,
//     self_service_users:
//       packages[0].prices.self_service_users +
//       packages[1].prices.self_service_users,
//   },
// });

packages.push({
  value: "ERPCOLLAB",
  label: "ERPCOLLAB",
  prices: {
    advance_users:
      packages[0].prices.advance_users + packages[2].prices.advance_users,
    core_users: packages[0].prices.core_users + packages[2].prices.core_users,
    self_service_users:
      packages[0].prices.self_service_users +
      packages[2].prices.self_service_users,
  },
});

function Licenses() {
  const navMetaData = useOutletContext();
  const { backendUrl, token, user } = useAuth();
  const [showFilter, setShowFilter] = useLocalStorage(
    "showLicensesFilter",
    true
  );

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [multiSelectionMode, setMultiSelectionMode] = useState(false);
  const [selectedLicense, setSelectedLicense] = useState(null);
  const [licenses, setLicenses] = useState([]);
  const [partners, setPartners] = useState([]);
  const [deployments, setDeployments] = useState([]);
  const [showCreateLicenseModal, setShowCreateLicenseModal] = useState(false);
  const [showLicenseDetailsModal, setShowLicenseDetailsModal] = useState(false);
  const [createdLicense, setCreatedLicense] = useState(null);
  const [copied, setCopied] = useState(false);
  const [query, setQuery] = useState("");
  const [scope, setScope] = useState("license");
  const [partnerCustomer, setPartnerCustomer] = useState([]);
  const [formData, setFormData] = useState({
    partnership_id: "",
    core_users: 0,
    advance_users: 0,
    self_service_users: 0,
    partnerCustomer: "",
    package: "ERP",
  });
  const [selectedPackage, setSelectedPackage] = useState(packages[0].value);
  const [licensePrice, setLicensePrice] = useState(0);

  const formRef = useRef();

  const initialFilterParams = {
    partnerName: "",
    licenseKey: "",
    startDate: "",
    endDate: "",
  };

  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });

  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });

  /**
   * Searches an array of license objects based on a query and scope.
   * @param {Array<Object>} data - The array of license objects.
   * @param {string} query - The search query.
   * @param {("license"|"partner"|"deployment")} scope - The scope to search within.
   * @returns {Array<Object>} Filtered results.
   */
  function searchLicenses(data, query, scope) {
    if (!query) return data; // if empty query return all

    // Convert query to lowercase for case-insensitive search.
    const q = query.toLowerCase();

    return data.filter(item => {
      // Search by the chosen scope.
      if (scope === "license") {
        // License scope: Check key, core_users, advance_users, or self_service_users.
        // Convert number values to string when comparing.
        return item.key && item.key.toLowerCase().includes(q);
      } else if (scope === "partner") {
        // Partner scope: Search partner fields if partner exists.
        if (item.partner) {
          return (
            (item.partner.company_name &&
              item.partner.company_name.toLowerCase().includes(q)) ||
            (item.partner.company_email &&
              item.partner.company_email.toLowerCase().includes(q)) ||
            (item.partner.personal_email &&
              item.partner.personal_email.toLowerCase().includes(q)) ||
            (item.partner.country &&
              item.partner.country.toLowerCase().includes(q)) ||
            (item.partner.state &&
              item.partner.state.toLowerCase().includes(q)) ||
            (item.partner.city &&
              item.partner.city.toLowerCase().includes(q)) ||
            (item.partner.first_name &&
              item.partner.first_name.toLowerCase().includes(q)) ||
            (item.partner.last_name &&
              item.partner.last_name.toLowerCase().includes(q))
          );
        }
        return false;
      } else if (scope === "deployment") {
        // Deployment scope: Search deployment fields if deployment exists.
        if (item.deployment) {
          return (
            (item.deployment.subdomain &&
              item.deployment.subdomain.toLowerCase().includes(q)) ||
            (item.deployment.company_name &&
              item.deployment.company_name.toLowerCase().includes(q)) ||
            (item.deployment.status &&
              item.deployment.status.toLowerCase().includes(q)) ||
            (item.deployment.features &&
              item.deployment.features.toLowerCase().includes(q))
          );
        }
        return false;
      }
      return false;
    });
  }
  useEffect(() => {
    const handlePackagePrice = () => {
      setLicensePrice(0);
      let prices = packages.find(pkg => pkg.value === selectedPackage)?.prices;
      setLicensePrice(() =>
        Object.keys(prices).reduce(
          (acc, key) => acc + prices[key] * Number(formData[key]),
          0
        )
      );
    };

    handlePackagePrice();
  }, [selectedPackage, formData]);

  const fetchLicenses = async query => {
    const res = await fetch(
      `${backendUrl}/api/partnership/licenses?${queryString.stringify(query)}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );
    if (res.ok) {
      const data = await res.json();
      return data;
    } else toast.error("Error getting licenses, please refresh the page");
  };

  const deleteLicense = async id => {
    if (
      await ConfirmDialog({
        title: "Are you sure you want to delete the license?",
        description: "You cannot retrieve a deleted license.",
      })
    ) {
      try {
        console.log(id);
        setIsLoading(true);
        const res = await fetch(`${backendUrl}/api/partnership/license/${id}`, {
          method: "DELETE",
          credentials: "include",
          headers: {
            Accept: "Application/json",
            "Content-Type": "Application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        });
        if (!res.ok) {
          let error = await res.json();
          throw new Error(error.message);
        }
        await refetch();
        toast.success("License deleted successfully");
      } catch (error) {
        console.log("error deleting license: ", error);
        toast.error(error.message);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const fetchPartnerCustomer = async partner => {
    try {
      const res = await fetch(
        `${backendUrl}/api/partnership/customers/${partner}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            Accept: "Application/json",
            "Content-Type": "Application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
      const [data] = await res.json();
      console.log(data);
      setPartnerCustomer(data.customers);
    } catch (error) {
      console.log(error);
      toast.error("unable to get partner's customers");
    }
  };

  const fetchPartners = async () => {
    try {
      const res = await fetch(
        `${backendUrl}/api/partnership/invexerp-partners`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            Accept: "Application/json",
            "Content-Type": "Application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
      const data = await res.json();
      console.log(data);
      setPartners(data.data);
    } catch (error) {
      console.error("Error fetching partners:", error);
      toast.error("Failed to fetch partners");
    }
  };

  const createLicense = async licenseData => {
    try {
      setIsLoading(true);
      const res = await fetch(`${backendUrl}/api/partnership/licenses`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(licenseData),
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });

      const data = await res.json();

      if (res.ok) {
        toast.success("License created successfully");
        setCreatedLicense(data); // Store the created license
        refetch();
        // Don't close the modal automatically so user can see the license
      } else {
        toast.error(data.message || "Failed to create license");
      }
    } catch (error) {
      console.error("Error creating license:", error);
      toast.error("An error occurred while creating the license");
    } finally {
      setIsLoading(false);
    }
  };

  const { data, refetch, isFetching, isSuccess } = useQuery(
    ["GET_LICENSES", queryParams],
    () => fetchLicenses(queryParams),
    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  useEffect(() => {
    if (data) {
      setLicenses(data.data);
    }

    if (data && data.metaData) {
      let active = data?.metaData.active;
      navMetaData({
        stat1: {
          value: data?.metaData.total,
          label: "Total licenses",
        },
        stat2: {
          value: active,
          label: "Active license",
        },
        stat3: {
          value: data?.metaData.total - active,
          label: "Used license",
        },
      });
    }
  }, [data]);

  useEffect(() => {
    fetchPartners();
    // fetchDeployments();
  }, []);

  const debouncedSearch = debounce((q, s) => {
    const filtered = searchLicenses(data?.data, q, s);
    setLicenses(filtered);
  }, 1000);

  useEffect(() => {
    debouncedSearch(query, scope);
  }, [query, data]);

  const handleFilterParamsChange = e => {
    const { name, value } = e.target;
    setFilterParams({
      ...filterParams,
      [name]: value,
    });
  };

  const handleFormChange = e => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const resetForm = () => {
    setFormData({
      partnership_id: "",
      core_users: 0,
      advance_users: 0,
      self_service_users: 0,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (
      await ConfirmDialog({
        title: "Create license for this partner",
        description: `
          <div className="partner-details" style="line-height: 8px">
            <div className="mb-2"><strong>Company name:</strong> ${formData
              .partnership_id?.data?.company_name || "N/A"}</div>
            <div className="mb-2"><strong>Email:</strong> ${formData
              .partnership_id?.data?.company_email || "N/A"}</div>
            <div className="mb-2"><strong>Contact Person:</strong> ${formData
              .partnership_id?.data?.first_name || "N/A"} ${formData
          .partnership_id?.data?.last_name || "N/A"}</div>
            <div className="mb-2"><strong>Phone:</strong> ${formData
              .partnership_id?.data?.phone_line || "N/A"}</div>
            <hr style="margin: 0">
            <div className="license-details">
              <h4>License Details:</h4>
              <div className="mb-1"><strong>Advance Users:</strong> ${
                formData.advance_users
              }</div>
              <div className="mb-1"><strong>Core Users:</strong> ${
                formData.core_users
              }</div>
              <div className="mb-1"><strong>Self Service Users:</strong> ${
                formData.self_service_users
              }</div>
            </div>
          </div>
        `,
      })
    ) {
      let packages =
        formData.package?.toLowerCase() === "erpcollab"
          ? [{ name: "collaborationTools" }, { name: "erp" }]
          : [{ name: formData?.package }];
      createLicense({
        ...formData,
        package: JSON.stringify(packages),
        partnership_id: formData.partnership_id?.value,
        partnerCustomer: formData.partnerCustomer?.value,
      });
    }
  };

  const search = () => {
    setQueryParams({
      ...queryParams,
      ...filterParams,
    });
  };

  const reset = () => {
    setFilterParams(initialFilterParams);
    setQueryParams({
      ...queryParams,
      ...initialFilterParams,
    });
    setQuery("");
  };

  const handleSearchQueryChange = e => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  const handleRenewLicense = async license => {
    try {
      if (
        await ConfirmDialog({
          description: `Are you sure you want to renew this license?`,
        })
      ) {
        setIsLoading(true);
        const res = await fetch(
          `${backendUrl}/api/licenses/${license.id}/renew`,
          {
            method: "PUT",
            credentials: "include",
            headers: {
              Accept: "Application/json",
              "Content-Type": "Application/json",
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
          }
        );

        const data = await res.json();

        if (res.ok) {
          toast.success("License renewed successfully");
          refetch();
        } else {
          toast.error(data.message || "Failed to renew license");
        }
      }
    } catch (error) {
      console.error("Error renewing license:", error);
      toast.error("An error occurred while renewing the license");
    } finally {
      setIsLoading(false);
    }
  };

  const copyToClipboard = text => {
    navigator.clipboard.writeText(text).then(
      () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      },
      err => {
        console.error("Could not copy text: ", err);
        toast.error("Failed to copy to clipboard");
      }
    );
  };

  const tableHead = () => {
    return (
      <thead className="position-sticky top-0">
        <tr>
          <th />

          <th>License Key</th>
          <th>Partner</th>
          <th>Deployment</th>
          <th>Core Users</th>
          <th>Advance Users</th>
          <th>Self Service Users</th>
          <th>Issued Date</th>
          <th>Expiry Status</th>
          <th>Created At</th>
        </tr>
      </thead>
    );
  };

  const getPartnerName = partnershipId => {
    const partner = partners.find(p => p.id === partnershipId);
    return partner ? partner.company_name : "Unknown Partner";
  };

  const getDeploymentName = deploymentId => {
    const deployment = deployments.find(d => d.id === deploymentId);
    return deployment ? deployment.name : "Not Assigned";
  };

  const tableData = (el, index) => {
    return (
      <>
        <td>
          <Dropdown>
            <Dropdown.Toggle
              variant=""
              className="bg-white border-0"
              bsPrefix="print more"
            >
              <DotsVerticalIcon />
            </Dropdown.Toggle>
            <Dropdown.Menu
              popperConfig={{
                strategy: "fixed",
              }}
              renderOnMount
              className="dropdown-with-icons"
            >
              <Dropdown.Item
                as="button"
                onClick={() => {
                  setSelectedLicense(el);
                  setShowLicenseDetailsModal(true);
                }}
              >
                <ViewIcon /> View License
              </Dropdown.Item>
              <Dropdown.Item
                tooltip={
                  el.expiry ? "Cannot delete used license" : "Delete license"
                }
                as="button"
                disabled={el.expiry}
                onClick={() => {
                  deleteLicense(el.id);
                }}
              >
                <DeleteIcon />
                Delete License
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </td>
        <td>{el?.key}</td>
        <td>{el?.partner?.company_name || "---"}</td>
        <td>{el?.deployment?.subdomain || "Not Assigned"}</td>
        <td>{el?.core_users}</td>
        <td>{el?.advance_users}</td>
        <td>{el?.self_service_users}</td>
        <td>
          {el?.issued_date ? (
            <>
              <div>{`${formatDate(
                new Date(el?.issued_date),
                "dd MMM, yyyy"
              )}`}</div>
              <div
                className=""
                style={{ fontSize: "12px", fontStyle: "italic" }}
              >
                {`${formatDate(new Date(el?.issued_date), "hh:mm a")}`}
              </div>
            </>
          ) : (
            "N/A"
          )}
        </td>
        <td
          className={`
            ${el?.expiry ? "text-danger fw-bold" : "text-success fw-bold"}
          `}
          style={{ textTransform: "capitalize" }}
        >
          {el?.expiry ? (el?.deployment_id ? "Used" : "Deactivated") : "Active"}
        </td>
        <td>
          {el?.created_at ? (
            <>
              <div>{`${formatDate(
                new Date(el?.created_at),
                "dd MMM, yyyy"
              )}`}</div>
              <div
                className=""
                style={{ fontSize: "12px", fontStyle: "italic" }}
              >
                {`${formatDate(new Date(el?.created_at), "hh:mm a")}`}
              </div>
            </>
          ) : (
            "N/A"
          )}
        </td>
      </>
    );
  };

  return (
    <>
      <Modal
        show={showCreateLicenseModal}
        onHide={() => {
          setShowCreateLicenseModal(false);
          setCreatedLicense(null); // Reset created license when closing modal
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Create New License</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!createdLicense ? (
            <Form onSubmit={handleSubmit} ref={formRef}>
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Package</Form.Label>
                    <Select
                      style={{
                        width: "100%",
                      }}
                      // autoFocus
                      classNamePrefix="form-select"
                      menuPosition="fixed"
                      menuPlacement="auto"
                      placeholder="Select package"
                      name="package"
                      onChange={e => {
                        if (e) {
                          setSelectedPackage(e.value);
                          setFormData(prev => ({
                            ...prev,
                            package: e.value,
                          }));
                        }
                      }}
                      // isSearchable={true}
                      value={packages.find(
                        pkg => pkg.value === selectedPackage
                      )}
                      options={packages
                        .filter(pkg => !["COLAB", "HR"].includes(pkg.value))
                        .map(pkg => ({
                          value: pkg.value,
                          label: pkg.label,
                        }))}
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Partner</Form.Label>
                    <Select
                      style={{
                        width: "100%",
                      }}
                      autoFocus
                      classNamePrefix="form-select"
                      menuPosition="fixed"
                      menuPlacement="auto"
                      placeholder="Select partner"
                      name="partnership_id"
                      isSearchable={true}
                      onChange={e => {
                        setFormData(prev => ({
                          ...prev,
                          partnerCustomer: "",
                          partnership_id: e,
                        }));
                        fetchPartnerCustomer(e.value);
                      }}
                      value={formData.partnership_id}
                      options={partners.map(partner => ({
                        value: partner.id,
                        label: `${partner.company_name} -- ${
                          partner.first_name
                        } ${partner.last_name}, ${partner.company_email}`,
                        data: partner,
                      }))}
                      isClearable
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Partner's customer</Form.Label>
                    <Select
                      style={{
                        width: "100%",
                      }}
                      classNamePrefix="form-select"
                      menuPosition="fixed"
                      menuPlacement="auto"
                      placeholder="Select partner"
                      name="partnerCustomer"
                      isSearchable={true}
                      onChange={e => {
                        setFormData(prev => ({
                          ...prev,
                          partnerCustomer: e,
                        }));
                      }}
                      value={formData.partnerCustomer}
                      options={partnerCustomer.map(customer => ({
                        value: customer.id,
                        label: `${customer.company_name} -- ${
                          customer.contact_name
                        }, ${customer.contact_email}`,
                        data: customer,
                      }))}
                      isClearable
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Advance Users</Form.Label>
                    <Form.Control
                      type="number"
                      name="advance_users"
                      value={formData.advance_users}
                      onChange={handleFormChange}
                      min="0"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Core Users</Form.Label>
                    <Form.Control
                      type="number"
                      name="core_users"
                      value={formData.core_users}
                      onChange={handleFormChange}
                      min="0"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Self Service Users</Form.Label>
                    <Form.Control
                      type="number"
                      name="self_service_users"
                      value={formData.self_service_users}
                      onChange={handleFormChange}
                      min="0"
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={12} className="p-4">
                  Amount:{" "}
                  {currency(licensePrice, {
                    symbol: "",
                  }).format()}
                </Col>
              </Row>
            </Form>
          ) : (
            <div className="license-created-container">
              <div className="alert alert-success mb-4">
                <h4 className="alert-heading">License Created Successfully!</h4>
                <p>
                  The license has been created for{" "}
                  <b>
                    {formData.partnership_id?.data?.company_name ||
                      "the selected partner"}
                  </b>
                  .
                </p>
              </div>

              <div className="license-details p-3 border rounded mb-4">
                <h5 className="mb-3">License Details</h5>
                <Row className="mb-2 h4">
                  <Col md={4}>
                    <strong>License Key:</strong>
                  </Col>
                  <Col md={8}>
                    <div className="d-flex align-items-center">
                      <code
                        className="me-2 p-2 rounded"
                        style={{ wordBreak: "break-all" }}
                      >
                        {createdLicense.key}
                      </code>
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => copyToClipboard(createdLicense.key)}
                      >
                        {copied ? "Copied!" : "Copy"}
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col md={4}>
                    <strong>Partner email:</strong>
                  </Col>
                  <Col md={8}>
                    {formData.partnership_id?.data?.company_email || "N/A"}
                  </Col>
                </Row>
                {formData.partnerCustomer && (
                  <Row className="mb-2">
                    <Col md={4}>
                      <strong>Partner's customer email:</strong>
                    </Col>
                    <Col md={8}>
                      {formData.partnerCustomer?.data?.contact_email || "N/A"}
                    </Col>
                  </Row>
                )}
                <Row className="mb-2">
                  <Col md={4}>
                    <strong>Advance Users:</strong>
                  </Col>
                  <Col md={8}>{createdLicense.advance_users}</Col>
                </Row>
                <Row className="mb-2">
                  <Col md={4}>
                    <strong>Core Users:</strong>
                  </Col>
                  <Col md={8}>{createdLicense.core_users}</Col>
                </Row>
                <Row className="mb-2">
                  <Col md={4}>
                    <strong>Self Service Users:</strong>
                  </Col>
                  <Col md={8}>{createdLicense.self_service_users}</Col>
                </Row>
                <Row className="mb-2">
                  <Col md={4}>
                    <strong>Created At:</strong>
                  </Col>
                  <Col md={8}>
                    {createdLicense.created_at
                      ? formatDate(
                          new Date(createdLicense.created_at),
                          "dd MMM, yyyy hh:mm a"
                        )
                      : "N/A"}
                  </Col>
                </Row>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!createdLicense ? (
            <>
              <Button
                variant="secondary"
                onClick={() => setShowCreateLicenseModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => formRef.current?.requestSubmit()}
                disabled={
                  isLoading ||
                  !(
                    Number(formData.self_service_users) +
                    Number(formData.core_users) +
                    Number(formData.advance_users)
                  )
                }
              >
                {isLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Creating...
                  </>
                ) : (
                  "Create License"
                )}
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="secondary"
                onClick={() => {
                  setShowCreateLicenseModal(false);
                  setCreatedLicense(null);
                  resetForm();
                }}
              >
                Close
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  setCreatedLicense(null);
                  resetForm();
                }}
              >
                Create Another License
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      <main className="cash-book ">
        <div className="content ">
          <div className="content-main pt-0">
            <div className={`filter-area ${showFilter ? "open" : "close"}`}>
              <div className="filter-header">
                <h2>
                  <FilterTwoIcon /> Filters
                </h2>

                <Button
                  variant="white"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <FilterCollapseIcon />
                </Button>
              </div>
              <div className="filter-body">
                <Form>
                  <div className="body">
                    <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Partner info</Form.Label>
                      <InputGroup>
                        <Form.Control
                          name="search"
                          value={filterParams.search}
                          placeholder="Enter partner details"
                          onChange={e => {
                            setQuery(e.target.value);
                            setScope("partner");
                          }}
                        />
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Deployment Details</Form.Label>
                      <InputGroup>
                        <Form.Control
                          name="deployment"
                          value={filterParams.deployment}
                          placeholder="Enter deployment details"
                          onChange={e => {
                            setQuery(e.target.value);
                            setScope("deployment");
                          }}
                        />
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>License Key</Form.Label>
                      <InputGroup>
                        <Form.Control
                          name="licenseKey"
                          value={filterParams.licenseKey}
                          placeholder="Enter license key"
                          onChange={e => {
                            setQuery(e.target.value);
                            setScope("license");
                          }}
                        />
                      </InputGroup>
                    </Form.Group>

                    <hr className="mt-3 mb-4" />
                  </div>

                  <div className="buttons rounded">
                    <Button onClick={reset} variant="white">
                      Reset
                    </Button>
                    <Button onClick={search} variant="primary">
                      Search
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
            <div className="content-body">
              <header>
                <h1>
                  {!showFilter && (
                    <button
                      onClick={() => setShowFilter(!showFilter)}
                      className="btn filter"
                    >
                      <FilterTwoIcon />
                    </button>
                  )}
                  License Management
                  <button
                    title="Refresh"
                    className="btn text-primary"
                    onClick={() => {
                      refetch();
                    }}
                  >
                    <CachedIcon />
                  </button>
                </h1>
                <div className="actions">
                  <Button
                    variant="primary"
                    onClick={() => setShowCreateLicenseModal(true)}
                  >
                    <AddCircleIcon className="me-2" />
                    Create New License
                  </Button>
                </div>
              </header>

              <div className="m-3">
                <TableComponent
                  responsive
                  borderless
                  striped
                  tableHeadsFunction={tableHead}
                  mainDataArray={licenses || []}
                  className="product-table text-nowrap"
                  tableDataRowFunction={tableData}
                />

                {!isFetching && isSuccess && isEmpty(data) ? (
                  <NoTableItem queryParams={queryParams} />
                ) : null}
              </div>

              <div className="d-flex justify-content-between px-3 align-items-center pagination">
                <div className="pagination_left">
                  <p className="m-0 p-0">Show</p>
                  <select
                    value={queryParams.limit}
                    name="limit"
                    className="form-select "
                    onChange={e => handleSearchQueryChange(e)}
                  >
                    <option value="10">10 rows</option>
                    <option value="20">20 rows</option>
                    <option value="30">30 rows</option>
                    <option value="40">40 rows</option>
                    <option value="50">50 rows</option>
                    <option value="100">100 rows</option>
                  </select>
                </div>

                <ReactPaginate
                  {...paginationOptions}
                  pageCount={
                    Math.ceil(data?.pagination.total / queryParams.limit) || 1
                  }
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={0}
                  onPageChange={({ selected }) => {
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                    setQueryParams({
                      ...queryParams,
                      page: selected + 1,
                    });
                  }}
                  forcePage={queryParams.page - 1}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
      {showLicenseDetailsModal && (
        <LicenseDetailsModal
          license={selectedLicense}
          show={showLicenseDetailsModal}
          onHide={() => setShowLicenseDetailsModal(false)}
          refetch={refetch}
        />
      )}
      {isLoading && (
        <div className="global-spinner">
          <LoaderIcon className="spin text-primary" />
        </div>
      )}
    </>
  );
}

export default Licenses;
